// Copyright (c) StrangeBee 2023

import React, { forwardRef, ReactElement } from 'react';

import './Footer.scss';

export interface FooterProps {
    children: ReactElement[] | ReactElement;
}

const Footer = forwardRef<HTMLDivElement, FooterProps>(({ children }, ref) => {
    const element = React.Children.toArray(children);

    const ChildBySlot = (element as ReactElement[]).reduce((acc, element) => {
        const currentSlot = acc[element.props.name] ? acc[element.props.name] : [];
        const children = element.props.children as ReactElement[];

        return element
            ? {
                  ...acc,
                  [element.props.name]: [
                      ...currentSlot,
                      {
                          ...element,
                          props: {
                              ...element.props,
                              children: children.map((child, index) => React.cloneElement(child, { ref, key: index })),
                          },
                      },
                  ],
              }
            : acc;
    }, {} as Record<string, ReactElement[]>);

    return (
        <footer className="th-list-footer">
            <div>{ChildBySlot['MANAGE']}</div>

            <div>{ChildBySlot['NAVIGATION']}</div>
        </footer>
    );
});

Footer.displayName = 'Footer';

export default Footer;
